import { imageExperienceContentStyle, editImageCommonStyle } from '@bingads-webui-campaign-react/common-styles';

export const adEditorStyle = ({ palette = {} }) => ({
  '& .kendo-listview-focused:focus, .kendo-listview-focused.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .ads-creative': {
    marginBottom: 20,
    padding: '0 10px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    backgroundColor: '#f4f4f4',
  },
  '& .campaign-adextension-list': {
    border: 'thin solid #bbb',
    width: 330,
    backgroundColor: '#f4f4f4',
    padding: 5,
    lineHeight: '15px',
  },
  '& .preview-tabs-unselected': {
    backgroundColor: 'white',
  },
  '& .adExtension-previewbox': {
    marginBottom: 5,
    wordBreak: 'break-all',
  },
  '& .adgroup-display': {
    marginTop: 30,
  },
  '& .panel-body-ad': {
    padding: '0 15px 0 15px',
  },
  '& .panel-body-ad > .form-group > .adgroup-selector': {
    marginBottom: '32px',
  },
  '& .adgroup-display-title': {
    color: '#333',
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: 12,
    wordWrap: 'break-word',
  },
  '& .adgroup-display-keyword': {
    color: '#666',
  },
  '& .native-ad-previewbox': {
    minHeight: 72,
    width: 400,
  },
  '& .adEditor-container': {
    width: 1100,
    padding: 8,
    paddingBottom: '0',
  },
  '& .preview-nav-pills': {
    marginBottom: 15,
  },
  '& .base-preview-box': {
    float: 'left',
    background: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    width: 250,
    margin: '20px 6px 0',
  },
  '& .adEditor-listitem': {
    float: 'left',
    background: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    width: 250,
    margin: '20px 6px 0',
    padding: '7px 5px',
    height: 100,
  },
  '& .adEditor-listitem:focus, & .adEditor-listitem.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .adEditor-error': {
    borderColor: 'red',
  },
  '& .adgroup-createBox': {
    float: 'left',
    background: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    width: 250,
    margin: '20px 6px 0',
    cursor: 'pointer',
    textAlign: 'center',
  },
  '& .adgroup-createBox-lg': {
    float: 'left',
    background: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    width: 250,
    margin: '20px 6px 0',
    cursor: 'pointer',
    textAlign: 'center',
    lineHeight: '100px',
    height: 100,
  },
  '& .adgroup-createBox-lg:focus, & .adgroup-createBox-lg.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .adgroup-createBox-sm': {
    float: 'left',
    background: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd #f1f1f1 #f1f1f1 #ddd',
    width: 250,
    margin: '20px 6px 0',
    cursor: 'pointer',
    textAlign: 'center',
    lineHeight: '75px',
    height: 75,
  },
  '& .adgroup-createBox-sm:focus, & .adgroup-createBox-sm.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .adgroup-dashedBox': {
    border: '1px dashed #333',
    margin: '20px 6px 0',
    opacity: '.3',
    width: 250,
    display: 'inline-block',
  },
  '& .adgroup-dashedBox-lg': {
    border: '1px dashed #333',
    margin: '20px 6px 0',
    opacity: '.3',
    width: 250,
    display: 'inline-block',
    height: 100,
  },
  '& .adgroup-dashedBox-lg.k-state-focused': {
    opacity: '1',
  },
  '& .adgroup-dashedBox-sm': {
    border: '1px dashed #333',
    margin: '20px 6px 0',
    opacity: '.3',
    width: 250,
    display: 'inline-block',
    height: 75,
  },
  '& .adgroup-dashedBox-sm.k-state-focused': {
    opacity: '1',
  },
  '& .bing-preview-container': {
    width: 565,
    backgroundColor: 'white',
    minHeight: 90,
    padding: '10px 10px 10px 10px',
  },
  '& .bing-preview-answer': {
    padding: '12px 0 0 35px',
  },
  '& .preview-ad-slug': {
    color: '#737373',
    fontSize: 12,
    fontWeight: 'bold',
  },
  '& .ext__displayUrl__domain': {
    width: '38%',
    float: 'left',
    wordBreak: 'break-all',
  },
  '& .ext__displayUrl__separator': {
    width: '4%',
    float: 'left',
  },
  '& .ext__displayUrl__path': {
    width: '27%',
    float: 'left',
  },
  '& .ext__displayUrl__domain--placeholder': {
    color: '#A2A2A2',
  },
  '& .preview-ad__description': {
    wordWrap: 'break-word',
  },
  '& .adEditor-toolbar': {
    backgroundColor: '#939393',
    height: 24,
    width: 248,
    textAlign: 'right',
    paddingRight: 10,
    marginLeft: -5,
    top: 20,
    position: 'relative',
  },
  '& .adEditor-toolbar ul': {
    minWidth: 170,
    whiteSpace: 'nowrap',
  },
  '& .adEditor-toolbar ul li': {
    position: 'relative',
  },
  '& .adEditor-toolbar ul li.divider': {
    margin: '0',
  },
  '& .adEditor-toolbar ul li:hover ul': {
    display: 'inline-block',
  },
  '& .adEditor-toolbar ul li>.btn': {
    fontWeight: 'normal',
    lineHeight: '1.25',
    border: 'none',
    background: 'none',
    textAlign: 'left',
    width: '100%',
    padding: '7px 10px',
  },
  '& .adEditor-toolbar ul li>.btn>.caret': {
    marginLeft: 8,
    marginRight: 5,
    borderTop: '4px solid transparent',
    borderRight: '0 dotted',
    borderLeft: '4px solid #000',
    borderBottom: '4px solid transparent',
  },
  '& .adEditor-toolbar ul li>.btn:focus, .adEditor-toolbar ul li>.btn.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .adEditor-toolbar ul li>.btn:hover': {
    backgroundColor: '#E5E5E5',
  },
  '& .adEditor-toolbar ul li label': {
    marginBottom: '0',
    fontWeight: 'normal',
  },
  '& .adEditor-toolbar>.btn-group>.btn-default': {
    fontWeight: 'normal',
    lineHeight: '1.25',
    border: 'none',
    background: 'none',
    textAlign: 'left',
    color: 'white',
    fontSize: 11,
    padding: 5,
    minWidth: 10,
  },
  '& .adEditor-toolbar>.btn-group>.btn-default>.caret': {
    marginLeft: 8,
    marginRight: 5,
  },
  '& .adEditor-toolbar>.btn-group>.btn-default:focus, .adEditor-toolbar>.btn-group>.btn-default.k-state-focused': {
    outline: '1px dashed #333 !important',
  },
  '& .adEditor-toolbar>.btn-group>.btn-default .caret': {
    borderTopColor: 'white',
  },
  '& .ad-rsa-filed-group .ad-pinned': {
    display: 'inline-block',
    fontSize: 9,
    width: 5,
  },
  '& .ad-rsa-filed-group .ad-rsa-pin-group': {
    position: 'absolute',
    top: 5,
    right: 11,
  },
  '& .ad-rsa-filed-group .ad-rsa-pin-group .visible': {
    visibility: 'visible !important',
  },
  '& .ad-rsa-filed-group .ad-rsa-pin-group .ad-field-position': {
    visibility: 'hidden',
  },
  '& .ad-rsa-filed-group:hover .ad-rsa-pin-group .ad-field-position': {
    visibility: 'visible',
  },
  '& .ad-rsa-add-headline, .ad-rsa-add-description': {
    textAlign: 'right',
    display: 'block',
    marginBottom: 20,
  },
  '& .ad-mma-add-headline, .ad-mma-add-long-headline, .ad-mma-add-description': {
    textAlign: 'right',
    textDecoration: 'none',
    display: 'block',
    '& .glyphicon-plus': {
      marginRight: 8,
    },
    '&.disabled': {
      color: palette.neutralTertiary,
    },
    '&:focus': {
      outline: '1px solid #605e5c',
    },
  },
  '& .crud-audience-ad .react-image-experience .crud-audience-ad-react .ad-edit-with-image-container': {
    overflow: 'visible',
    padding: '0 10px 0 0',
    marginLeft: -2,
  },
  '& .crud-audience-ad .react-image-experience .crud-audience-ad-react .ad-edit-with-image-container .ad-creation-content': {
    padding: '0 20px 5px 10px',
  },
  '& .crud-audience-ad .ad-edit-with-image-container': {
    overflow: 'visible',
    padding: '10px 50px 10px 15px',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .image-manager-container .image-group': {
    display: 'inline-block',
    verticalAlign: 'top',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .image-manager-container .image-group .img-type-title': {
    marginTop: '0',
    textAlign: 'left',
    fontWeight: 'bold',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .image-manager-container .image-group .title-text': {
    display: 'inline',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .image-required-error': {
    marginBottom: 15,
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content': {
    padding: 15,
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .row': {
    maxWidth: 'none',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .short-headline .input-group, .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .long-headline .input-group, .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .description .input-group, .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .business-name .input-group': {
    width: '100%',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .final-url .container-fluid, .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .mobile-url .container-fluid': {
    padding: '0',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .form-group': {
    marginLeft: '0',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls': {
    marginTop: '20px',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .row': {
    display: 'flex',
    flexDirection: 'column',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .row label.col-sm-4.control-label.accordion': {
    width: 'auto',
    padding: '0',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .impression-tracking-url-preview__container .row': {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .impression-tracking-url-preview__container .row .impression-tracking-url-preview__label': {
    paddingRight: '10px',
    whiteSpace: 'nowrap',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .impression-tracking-url-preview__container .row .impression-tracking-url-preview__label span': {
    display: 'block',
    width: '150px',
  },
  '& .crud-audience-ad .ad-edit-with-image-container .ad-creation-content .ad-properties-section .impression-tracking-urls .form-group .impression-tracking-url-preview__container .impression-tracking-url-preview__value span': {
    display: 'block',
    maxWidth: '200px',
    overflowWrap: 'break-word',
    padding: '0',
    fontWeight: 'normal',
  },
  '& .image-experience-content .image-list-view-content': {
    position: 'relative',
  },
  '& .image-experience-content .image-list-view-content .remove-all-button': {
    marginBottom: 5,
  },
  '& .image-experience-content .image-list-view-content .image-list': {
    margin: '10px 0',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-label': {
    fontSize: 12,
    fontWeight: '700',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item': {
    border: 'none',
    position: 'relative',
    float: 'left',
    padding: 5,
    fontSize: 12,
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-item-ratio-label': {
    marginTop: 5,
    height: '20px !important',
    textAlign: 'center',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item:hover .image-list-item-image .dropdown.btn-group': {
    display: 'block',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item:focus': {
    outline: 'none !important',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image': {
    position: 'relative',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group': {
    display: 'none',
    position: 'absolute',
    width: '100%',
    bottom: '0',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group.image-edit-dropdown .dropdown-toggle': {
    color: 'white',
    background: 'rgba(0,0,0,0.3)',
    width: '100%',
    border: '0',
    padding: 2,
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group .dropdown-menu': {
    margin: '0',
    borderRadius: '0',
    border: '2px solid rgba(0,0,0,0.15)',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group .dropdown-menu li a': {
    paddingLeft: 10,
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item.empty-image-list-item button': {
    border: 'dashed',
    background: 'white',
    borderColor: '#CCCCCC',
    borderWidth: 'thin',
    color: '#00a2ff',
    textAlign: 'center',
  },
  '& .image-experience-content .image-list-view-content .image-list .image-list-item.empty-image-list-item button:focus': {
    outline: 'none !important',
  },
  '& .new-preview-carousel-container': {
    width: 920,
    position: 'relative',
    marginTop: 15,
    right: '0',
    border: 'solid grey 1px',
    background: 'white',
  },
  '& .new-preview-carousel-container .ad-preview-title': {
    color: '#333333',
    fontWeight: '700',
    margin: '7px 0 0 10px',
    fontSize: 12,
  },
  '& .new-preview-carousel-container .alert.alert-info.form-group': {
    margin: '5px 0 0 0',
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-indicators': {
    bottom: '0',
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-indicators li': {
    border: '1px solid #999999',
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-indicators li.active': {
    background: '#207697',
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-control': {
    background: 'transparent',
    color: '#474747',
    width: 80,
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-control .glyphicon-chevron-left': {
    top: '50%',
    marginLeft: -30,
  },
  '& .new-preview-carousel-container .carousel.slide .carousel-control .glyphicon-chevron-right': {
    top: '50%',
    marginRight: -30,
  },
  '& .new-preview-carousel-container .disclaimer-info': {
    fontSize: 12,
    padding: 5,
  },
  '& .new-preview-carousel-container .crop-image-button': {
    marginRight: 8,
  },
  '& .new-responsive-ad-preview-container': {
    fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
    fontSize: 10,
    height: 540,
    position: 'relative',
  },
  '& .new-responsive-ad-preview-container .responsive-ad-preview-content': {
    boxSizing: 'unset',
    position: 'absolute',
    top: '47%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    margin: '0',
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .preview-type-string': {
    position: 'absolute',
    bottom: 75,
    fontSize: 12,
    textAlign: 'center',
    width: '100%',
  },
  // '.image-experience-content .modal-container': {
  //   position: 'fixed',
  //   zIndex: '1070',
  //   left: '0',
  //   top: '0',
  //   width: '100%',
  //   height: '100%',
  //   overflow: 'auto',
  //   backgroundColor: 'rgba(0,0,0,0.4)',
  // },
  // '.image-experience-content .modal-content': {
  //   backgroundColor: '#fefefe',
  //   margin: '15% auto',
  //   padding: 20,
  //   border: '1px solid #888',
  //   minWidth: 650,
  //   width: '80%',
  // },
  '& .applookup': {
    width: 355,
  },
  '& .applookup .noresultsfound': {
    color: '#D90026',
  },
  '& .applookup-results-image': {
    height: 47,
    width: 47,
  },
  '& .appinfo-image': {
    height: 18,
    width: 18,
  },
  '& .appinfo-edit-button': {
    border: 'none',
    background: 'none',
  },
  '& .appinfo-appicon': {
    border: 'none',
    background: 'none',
  },
  '& .appresult': {
    padding: '0',
  },
  '& .campaign-adgroup-list': {
    border: 'thin solid #bbb',
    backgroundColor: '#E5E5E5',
    padding: 5,
    lineHeight: '15px',
  },
  '& .scrollable-appresult': {
    maxHeight: 250,
    overflow: 'auto',
    border: '1px #BBB solid',
    marginBottom: 5,
  },
  '& .applookup-results-row': {
    height: 60,
    borderBottom: '1px #BBB solid',
  },
  '& .applookup-results-table': {
    cursor: 'default',
    width: '100%',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
  },
  '& .applookup-results-table tr:hover': {
    backgroundColor: '#F9F9F9',
  },
  '& .applookup-results-table img': {
    marginLeft: 5,
  },
  '& .appinfo-table': {
    border: '1px solid #BBB',
    backgroundColor: '#fff',
    cursor: 'default',
    height: 60,
    width: '100%',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
  },
  '& .appinfo-table img': {
    marginLeft: 5,
  },
  '& .change-app-edit': {
    float: 'right',
    marginTop: 4,
    display: 'inline-block !important',
  },
  '& .block-app-icon': {
    display: 'inline-block !important',
    marginTop: 2,
  },
  '& .lookup-placeholder': {
    color: '#605e5c',
    cursor: 'default',
  },
  '& .dropdownContainer': {
    width: '100% !important',
  },
  '& .applookup-popover .popover': {
    top: '25px !important',
  },
  '& .applookup-popover .blocker-size, .applookup-selected-popover .blocker-size': {
    height: '38%',
  },
  '& .applookup-dropdown .popover': {
    left: '14px !important',
    marginTop: '0 !important',
  },
  '& .edit-selectedapp': {
    marginRight: 2,
  },
  '& .app-icon': {
    width: 50,
  },
  '& .app-details': {
    width: 220,
    padding: '2px 0 2px 2px',
  },
  '& .app-actions': {
    paddingTop: 3,
    verticalAlign: 'text-top',
    width: 15,
  },
  '& .app-result-details': {
    width: 260,
    padding: 2,
  },
  '& .wrap-long-text': {
    wordBreak: 'break-all',
    wordWrap: 'break-word',
  },
  '& .validation-error': {
    border: '1px solid #D90026 !important',
    backgroundColor: '#FFEBEB',
  },
  '& .itemTemplate-text': {
    display: 'inline-block',
    paddingLeft: 5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    verticalAlign: 'bottom',
  },
  '& .action-radio td': {
    paddingRight: 10,
  },
  '& .preview-wrap-long-text': {
    wordWrap: 'break-word',
  },
  '& .app-install-mobile-preview': {
    marginTop: 5,
  },
  '& .app-install-mobile-preview .preview-app-details div': {
    width: 130,
    height: 38,
    overflow: 'hidden',
  },
  '& .bulkedit .doubleListBox .dlb-source-container, & .bulkedit .doubleListBox .dlb-selected-container': {
    height: 270,
  },
  '& .app-install-tablet-preview': {
    marginTop: 5,
  },
  '& .app-install-tablet-preview .preview-app-details div': {
    width: 335,
    height: 38,
    overflow: 'hidden',
  },
  '& .errors-container': {
    maxWidth: 915,
  },
  '& .errors-container .error-grid-container': {
    paddingTop: 10,
    height: 'auto',
  },
  '& .errors-container .error-grid-container .viewport': {
    maxHeight: 200,
  },
  '& .errors-container .error-grid-container td': {
    wordBreak: 'normal',
  },
  '& .errors-container .error-grid-container .error-grid-col': {
    backgroundColor: '#fff',
    paddingLeft: 5,
    paddingRight: 5,
  },
  '& .preview-app-details': {
    fontFamily: 'Arial,Helvetica,Sans-Serif',
    fontSize: 13,
  },
  '& .preview-app-icon': {
    width: 38,
  },
  '& .preview-app-icon img': {
    height: 36,
    width: 36,
  },
  '& .preview-app-icon-border': {
    border: '1px solid #A2A2A2',
  },
  '& .preview-app-actions button': {
    background: 'transparent',
    border: '1px solid #BBB',
    color: '#0044CC',
    opacity: '1 !important',
  },
  '& .app-install-sample-image-preview': {
    height: 30,
    width: 30,
    background: 'transparent url(\'../Images/Clus/AppIcons2.png\') no-repeat scroll -2px -162px',
  },
  '& .app-preview-title': {
    fontFamily: '\'Segoe UI\',Arial,Helvetica,Sans-Serif',
    fontSize: '18px !important',
  },

  '& .website-image-opt-in': {
    marginTop: 32,

    '& a.helpbutton': {
      verticalAlign: 'top',
    },

    '& #website-image-opt-in-checkbox': {
      verticalAlign: 'bottom',
      marginLeft: -28,
      marginRight: 8,
    },

    '& span.website-image-checkbox-label': {
      display: 'inline-block',
      paddingLeft: 28,
    },
  },
  ...imageExperienceContentStyle(),
  ...editImageCommonStyle(),
});
